export const charges = [
  {
    defendant: "Daniel Michael Ciccone",
    link: "https://obd.hcraontario.ca/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 69 homes - Stateview Homes (Nao Towns) Inc. ",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "https://obd.hcraontario.ca/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 12 homes - Stateview Homes (Hampton Heights) Inc.",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "https://obd.hcraontario.ca/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 131 homes - Stateview Homes (Minu Towns) Inc.",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "https://obd.hcraontario.ca/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) –Officer/Director of a Company who fails to comply with condition of licence - representing 47 homes - Stateview Homes (Elia Collection) Inc.",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "https://obd.hcraontario.ca/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 37(1) – Officer/Director of a Company who acted as a vendor of a new home without a licence - representing 44 homes - Stateview Homes (Queens Court) Inc.",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "https://obd.hcraontario.ca/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 20 homes - Stateview Homes (Queens Court) Inc.",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "https://obd.hcraontario.ca/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 128 homes - Stateview Homes (Elm&Co) Inc.",
  },
  {
    defendant: "Daniel Michael Ciccone",
    link: "https://obd.hcraontario.ca/unlicensed/B64166",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) –Officer/Director of a Company who fails to comply with condition of licence - representing 2 homes - Stateview Homes (On the Mark) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 69 homes - Stateview Homes (Nao Towns) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 12 homes - Stateview Homes (Hampton Heights) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 131 homes - Stateview Homes (Minu Towns) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 47 homes - Stateview Homes (Elia Collection) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 44 homes - Stateview Homes (Queens Court) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 20 homes - Stateview Homes (Queens Court) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence - representing 128 homes - Stateview Homes (Elm&Co) Inc.",
  },
  {
    defendant: "Dino Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B64165",
    dLocation: "Woodbridge",
    oLocation: "Woodbridge",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(3) – Other Individuals – Fail to take reasonable care to prevent offence- representing 2 homes - Stateview Homes (On the Mark) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 69 homes - Stateview Homes (Nao Towns) Inc. ",
  },
  {
    defendant: "Carlo Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 12 homes - Stateview Homes (Hampton Heights) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 131 homes - Stateview Homes (Minu Towns) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) –Officer/Director of a Company who fails to comply with condition of licence - representing 47 homes - Stateview Homes (Elia Collection) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 37(1) – Officer/Director of a Company who acted as a vendor of a new home without a licence - representing 44 homes - Stateview Homes (Queens Court) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 20 homes - Stateview Homes (Queens Court) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Officer/Director of a Company who fails to comply with condition of licence - representing 128 homes - Stateview Homes (Elm&Co) Inc.",
  },
  {
    defendant: "Carlo Taurasi",
    link: "https://obd.hcraontario.ca/unlicensed/B41133",
    dLocation: "Richmond Hill ON",
    oLocation: "Richmond Hill ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) –Officer/Director of a Company who fails to comply with condition of licence - representing 2 homes - Stateview Homes (On the Mark) Inc.",
  },
  {
    defendant: "Stateview Homes (On The Mark) Inc.",
    link: "https://obd.hcraontario.ca/profile/B48325",
    dLocation: "Woodbridge ON",
    oLocation: "Markham ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 2 homes",
  },
  {
    defendant: "Stateview Homes (Queen's Court) Inc.",
    link: "https://obd.hcraontario.ca/profile/B61656",
    dLocation: "Woodbridge ON",
    oLocation: "Brampton ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 37(1) – Acted as a vendor of a new home without a licence - representing 44 homes",
  },
  {
    defendant: "Stateview Homes (Queen's Court) Inc.",
    link: "https://obd.hcraontario.ca/profile/B61656",
    dLocation: "Woodbridge ON",
    oLocation: "Brampton ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 20 homes",
  },
  {
    defendant: "Stateview Homes (Elia Collection) Inc.",
    link: "https://obd.hcraontario.ca/profile/B61334",
    dLocation: "Woodbridge ON",
    oLocation: "Newmarket ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 47 homes",
  },
  {
    defendant: "Stateview Homes (Elm&Co) Inc.",
    link: "https://obd.hcraontario.ca/profile/B61469",
    dLocation: "Woodbridge ON",
    oLocation: "Whitchurch- Stouffville ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 128 homes",
  },
  {
    defendant: "Stateview Homes (Minu Towns) Inc.",
    link: "https://obd.hcraontario.ca/profile/B60578",
    dLocation: "Woodbridge ON",
    oLocation: "Markham ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 131 homes",
  },
  {
    defendant: "Stateview Homes (Hampton Heights) Inc.",
    link: "https://obd.hcraontario.ca/profile/B60363",
    dLocation: "Woodbridge ON",
    oLocation: "Barrie ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 12 homes",
  },
  {
    defendant: "Stateview Homes (Nao Towns) Inc.",
    link: "https://obd.hcraontario.ca/profile/B48820",
    dLocation: "Woodbridge ON",
    oLocation: "Markham ON",
    chargeDate: "April 22, 2025",
    charge:
      "NHCLA-Section 71(1)(b) – Fails to comply with Condition of License - representing 69 homes",
  },
  {
    defendant: "Syed Nasir Ali Shah",
    link: "https://obd.hcraontario.ca/profile/B44757",
    dLocation: "Bolton, ON",
    oLocation: "Simcoe, ON",
    chargeDate: "July 5, 2021",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Vendor of a New Home",
  },
  {
    defendant: "Exquisite Bay Development Inc.",
    link: "https://obd.hcraontario.ca/profile/B44757",
    dLocation: "Mississauga, ON",
    oLocation: "Mississauga, ON",
    chargeDate: "January 19, 2024",
    charge: "Section 37(1) – Vendor NHCLA",
  },
  {
    defendant: "Exquisite Bay Development Inc.",
    link: "https://obd.hcraontario.ca/profile/B44757",
    dLocation: "Mississauga, ON",
    oLocation: "Mississauga, ON",
    chargeDate: "January 19, 2024",
    charge: "Section 37(1) – Vendor NHCLA",
  },
  {
    defendant: "Ahmed Raza Yousuf",
    link: "https://obd.hcraontario.ca/profile/B44757",
    dLocation: "Mississauga, ON",
    oLocation: "Mississauga, ON",
    chargeDate: "January 19, 2024",
    charge: "Section 37(1) – Vendor Officer/Director NHCLA",
  },
  {
    defendant: "Ahmed Raza Yousuf",
    link: "https://obd.hcraontario.ca/profile/B44757",
    dLocation: "Mississauga, ON",
    oLocation: "Mississauga, ON",
    chargeDate: "January 19, 2024",
    charge: "Section 37(1) – Vendor Officer/Director NHCLA",
  },
  {
    defendant: "Matoma Corporation",
    link: "https://obd.hcraontario.ca/unlicensed/B46630",
    dLocation: "Barrie, ON",
    oLocation: "The Blue Mountains, ON",
    chargeDate: "January 16, 2024",
    charge: "ONHWPA - Section 6 - Illegally acted as a Builder of a new home",
  },
  {
    defendant: "Matoma Corporation",
    link: "https://obd.hcraontario.ca/unlicensed/B46630",
    dLocation: "Barrie, ON",
    oLocation: "The Blue Mountains, ON",
    chargeDate: "January 16, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Tomas Joseph Pavlovic",
    link: "https://obd.hcraontario.ca/unlicensed/100466551",
    dLocation: "Mississauga, ON",
    oLocation: "The Blue Mountains, ON",
    chargeDate: "January 16, 2024",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company who Illegally acted as a Builder of a New Home",
  },
  {
    defendant: "Tomas Joseph Pavlovic",
    link: "https://obd.hcraontario.ca/unlicensed/100466551",
    dLocation: "Mississauga, ON",
    oLocation: "The Blue Mountains, ON",
    chargeDate: "January 16, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  },
  {
    defendant: "Shaheda Karim Jesmin",
    link: "https://obd.hcraontario.ca/unlicensed/B63487",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
  },
  {
    defendant: "Kanada Homes and Property Construction Inc.",
    link: "https://obd.hcraontario.ca/unlicensed/B63486",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) - Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 10.2(4) - Builder fail to Enrol (shall not commence construction)",
  },
  {
    defendant: "Albion Building Consultant Inc.",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 37(2) - Acted as a builder of a new home without a licence",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company who Failed to Enrol a New Home",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 37(1) - Officer/Director of a Company who acted as a vendor of a new home without a licence",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 37(2) -Officer/Director of a Company who acted as a builder of a new home without a licence",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "POA - Section 77(1) - Knowingly acted as a Party to an Offence ",
  },
  {
    defendant: "Zamal Hossain",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "POA - Section 77(1) - Knowingly acted as a Party to an Offence ",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "Section 71(1)(b) – Officer/Director  of a Company who Fails to comply with Condition of Licence NHCLA",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "POA - Section 77(1) - Knowingly acted as a Party to an Offence ",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "POA - Section 77(1) - Knowingly acted as a Party to an Offence ",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge: "ONHWPA - Section 6 - Illegally acted as a Vendor of a new home",
  },
  {
    defendant: "Farida Haque",
    link: "https://obd.hcraontario.ca/profile/B47109",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 37(2) - Officer/Director of a Company who acted as a vendor of a new home without a licence",
  },
  {
    defendant: "Al-Leem Kassam o/a Creative Design & Construction",
    link: "https://obd.hcraontario.ca/unlicensed/B61137",
    dLocation: "Richmond Hill, ON",
    oLocation: "Port McNicoll, ON",
    chargeDate: "November 21, 2023",
    charge:
      "NHCLA-Section 37(2)-Acted as a builder of a new home without a licence",
    convictionDate: "December 19, 2024",
    result: "Convicted Fine",
    fineAmount: "$18,750.00",
  },
  {
    defendant: "Al-Leem Kassam o/a Creative Design & Construction",
    link: "https://obd.hcraontario.ca/unlicensed/B61137",
    dLocation: "Richmond Hill, ON",
    oLocation: "Port McNicoll, ON",
    chargeDate: "November 21, 2023",
    charge:
      "NHCLA-Section 37(2)-Held oneself out as a builder of a new home without a licence",
    convictionDate: "December 19, 2024",
    result: "Convicted Fine",
    fineAmount: "$25,000.00",
  },
  {
    defendant: "Al-Leem Kassam o/a Creative Design & Construction",
    link: "https://obd.hcraontario.ca/unlicensed/B61137",
    dLocation: "Richmond Hill, ON",
    oLocation: "Port McNicoll, ON",
    chargeDate: "November 21, 2023",
    charge: "NHCLA-Section 71(1)(c)-Failed to comply with an order",
    convictionDate: "December 19, 2024",
    result: "Convicted Fine",
    fineAmount: "$31,250.00",
  },
  {
    defendant: "Al-Leem Kassam o/a Creative Design & Construction",
    link: "https://obd.hcraontario.ca/unlicensed/B61137",
    dLocation: "Richmond Hill, ON",
    oLocation: "Port McNicoll, ON",
    chargeDate: "November 21, 2023",
    charge: "",
    convictionDate: "December 19, 2024",
    result: "Restitution Order",
    fineAmount: "$154,122.00",
  },
  {
    defendant: "Al-Leem Kassam o/a Creative Design & Construction",
    link: "https://obd.hcraontario.ca/unlicensed/B61137",
    dLocation: "Richmond Hill, ON",
    oLocation: "Port McNicoll, ON",
    chargeDate: "November 21, 2023",
    charge: "",
    convictionDate: "December 19, 2024",
    result: "Restitution Order",
    fineAmount: "$40,000.00",
  },
  {
    defendant: "Mashiat Mutmainnah",
    link: "https://obd.hcraontario.ca/unlicensed/B63488",
    dLocation: "Toronto, ON",
    oLocation: "Toronto, ON",
    chargeDate: "August 21, 2024",
    charge:
      "NHCLA - Section 37(1) – Acted as a vendor of a new home without a licence",
    fineAmount: "$7,500.00",
    convictionDate: "May 16, 2025",
    result: "Convicted Fine",
  },
  {
    defendant: "James Lischkoff",
    link: "https://obd.hcraontario.ca/unlicensed/600018634",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge:
      "ONHWPA - Section 6 - Officer/Director of a Company that Illegally acted as a Builder of a New Home",
    result: "Convicted Fine",
    fineAmount: "$15,000.00",
    convictionDate: "April 14, 2025",
  },
  {
    defendant: "James Lischkoff",
    link: "https://obd.hcraontario.ca/unlicensed/600018634",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge:
      "ONHWPA - Section 12 - Officer/Director of a Company that Failed to Enrol a New Home",
    result: "Suspended Sentence",
    convictionDate: "April 14, 2025",
  },
  {
    defendant: "James Lischkoff",
    link: "https://obd.hcraontario.ca/unlicensed/600018634",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge:
      "NHCLA - Section 37(2) - Officer/Director of a Company that acted as a builder of a new home without a licence",
    result: "Convicted Fine",
    fineAmount: "$15,000.00",
    convictionDate: "April 14, 2025",
  },
  {
    defendant: "James Lischkoff",
    link: "https://obd.hcraontario.ca/unlicensed/600018634",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge:
      "ONHWPA - Section 10.2(3)- Officer/Director of a Company that entered into a contract and failed to receive enrolment confirmation",
    result: "Suspended Sentence",
    convictionDate: "April 14, 2025",
  },
  {
    defendant: "James Lischkoff",
    link: "https://obd.hcraontario.ca/unlicensed/600018634",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge: "",
    result: "Restitution Order",
    fineAmount: "$130,000.00",
    convictionDate: "April 14, 2025",
  },
  {
    defendant: "James Lischkoff",
    link: "https://obd.hcraontario.ca/unlicensed/600018634",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge: "",
    result: "Restitution Order",
    fineAmount: "$25,000.00",
    convictionDate: "April 14, 2025",
  },
  {
    defendant: "Lischkoff Build Design Ltd.",
    link: "https://obd.hcraontario.ca/unlicensed/B62919",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge: "ONHWPA - Section 6 - Illegally acted as a Builder of a new home",
    convictionDate: "April 14, 2025",
    result: "Convicted Fine",
    fineAmount: "$15,000.00",
  },
  {
    defendant: "Lischkoff Build Design Ltd.",
    link: "https://obd.hcraontario.ca/unlicensed/B62919",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge: "ONHWPA - Section 12 - Failed to Enrol a New Home",
    convictionDate: "April 14, 2025",
    result: "Suspended Sentence",
  },
  {
    defendant: "Lischkoff Build Design Ltd.",
    link: "https://obd.hcraontario.ca/unlicensed/B62919",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge:
      "Section 37(2) – Acted as a builder of a new home without a licence",
    convictionDate: "April 14, 2025",
    result: "Convicted Fine",
    fineAmount: "$15,000.00",
  },
  {
    defendant: "Lischkoff Build Design Ltd.",
    link: "https://obd.hcraontario.ca/unlicensed/B62919",
    dLocation: "Utterson, ON",
    oLocation: "Township of Chatsworth, ON",
    chargeDate: "February 6, 2024",
    charge:
      "ONHWPA - Section 10.2(3) - Builder entered into a contract and failed to receive enrolment confirmation",
    convictionDate: "April 14, 2025",
    result: "Suspended Sentence",
  },
];
